import React, { SVGAttributes } from "react";
import styled from "styled-components";
import * as icons from "../../shared/Icons";
import get from "lodash/get";

interface SvgProps extends SVGAttributes<SVGSVGElement> {
    pathRules?: SVGAttributes<SVGPathElement>;
    iconPath: keyof typeof icons;
    colorVariant?: string;
    onClick?: () => void;
    customDisplay?: "block" | "inline";
}

const StyledIcon = styled.svg<Partial<SvgProps>>`
    display: ${(props) => props.customDisplay};
`;

interface StyledPathProps {
    colorVariant: string;
}

const StyledPath = styled.path<StyledPathProps>`
    fill: ${(props) => get(props.theme.colors, props.colorVariant, "none")};
`;

const Icon = ({ ...props }: SvgProps) => {
    const { iconPath, pathRules, customDisplay, ...rest } = props;

    return (
        <StyledIcon viewBox="0 0 24 24" width="24px" height="24px" {...rest}>
            <StyledPath d={icons[iconPath]} colorVariant={props.colorVariant} {...pathRules} />
        </StyledIcon>
    );
};

export default Icon;
